module.exports = __webpack_public_path__ + "static/media/eye.8d8257ab.svg";